<template>
	<div class="exchange">
		<back-to></back-to>
		<!-- 列表 -->
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false"
			class="orderList-list">
			<div class="orderList-item" v-for="(item,index) in list" :key="index">
				<span class="orderList-itemt">
					<label for="" class="orderList-itemt-left">
						<span class="orderList-itemt-left1">
							<img :src="item.scoreProductUrl" alt="">
							<p v-if="item.status == 1">兑换成功</p>
							<p v-if="item.status == 2">兑换失败</p>
						</span>
						<span class="orderList-itemt-left2">
							<p class="item-s-t">{{item.scoreProductName}}</p>
							<p class="item-s-s">兑换时间:{{item.exchangeTime|formateDate}}</p>
							<p class="item-s-d" v-if="item.scoreProductTypeId!=3">收货人:{{item.name}}</p>
						</span>
					</label>
					<label for="" class="orderList-itemt-right">
						<p v-if="item.sendStatus==1">待发货</p>
						<p v-if="item.sendStatus==2">已发货</p>
						<p>{{item.useScore}}积分</p>
					</label>
				</span>
				<span class="orderList-itemb" v-if="item.scoreProductTypeId!=3">
					<p>收货地址:{{item.province}}{{item.city}}{{item.area}}{{item.address}}</p>
				</span>
			</div>
		</van-list>
	</div>
</template>

<script>
	import {
		formatTime
	} from '@/config/util'
	import {
		mapGetters
	} from 'vuex'
	import BackTo from '@/components/BackTo.vue'
	export default {
		name: 'exchange',
		components: {
			BackTo
		},
		data() {
			return {
				loading: false,
				finished: false,
				pageIndex: 1,
				list: []
			}
		},
		filters: {
			formateDate(time) {
				let date = new Date(time)
				return formatTime(date)
			}
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		mounted() {
			this.getList()
		},
		methods: {
			onLoad() {
				setTimeout(() => {
					this.loading = false;
					this.pageIndex = this.pageIndex + 1
					this.getList()
				}, 500);
			},
			getList() {
				let param = {
					"ptId": this.$organizationId,
					"userId": this.userInfo.userId,
					"pageIndex": this.pageIndex,
					"pageSize": 10
				}
				this.$post(
					this.$activity + '/Score/ScoreExchangeGetAll', param
				).then(res => {
					this.list = this.list.concat(res.items)
					if (res.items.length < 10) {
						this.finished = true;
					}
				})
			},
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f2f2f2')
		}
	}
</script>

<style scoped>
	.orderList-list {
		width: 100%;
		padding: 20px 30px;
		box-sizing: border-box;
	}

	.orderList-item {
		width: 100%;
		background-color: #fff;
		border-radius: 16px;
		margin-bottom: 20px;
		padding: 20px;
		box-sizing: border-box;
	}

	.orderList-itemt {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
	}

	.orderList-itemt-left {
		display: flex;
		align-items: center;
		font-size: 28px;
		color: #999;
		width: 530px;
	}

	.orderList-itemt-left1 {
		position: relative;
		height: 130px;
		width: 130px;
		border-radius: 12px;
		overflow: hidden;
	}

	.orderList-itemt-left1 p {
		width: 100%;
		height: 30px;
		background: rgba(0, 0, 0, 0.5);
		position: absolute;
		bottom: 0;
		right: 0;
		font-size: 20px;
		color: #fff;
		text-align: center;
		line-height: 30px;
	}

	.orderList-itemt img {
		height: 130px;
		width: 130px;
	}

	.orderList-itemb {
		padding-top: 20px;
		font-size: 27px;
		color: #999;
		display: inline-block;
	}

	.orderList-itemt-left2 {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 130px;
		padding-left: 14px;
		width: 400px;
	}

	.item-s-t {
		font-size: 28px;
		color: #333;
		font-weight: bold;
		width: 400px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
	}

	.orderList-itemt-right {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 130px;
		align-items: flex-end;
		font-size: 26px;
		color: #ff8a00;
		font-weight: bold;
		width: 120px;
	}
</style>
